import React, { FC, useEffect } from "react";

import { useSelector, useDispatch } from "react-redux";
import { RootState, Dispatch } from "../../../store";

import Attestation from "./Attestation";
import { IAttessation } from "../../../types/interfaces";
import Typography from "../../../components/Typography/Typography";
import { ClipLoader } from "react-spinners";
interface IProps {
  searchLoading: boolean;
  filteredAttestations?: IAttessation[];
}
const AllAttesations: FC<IProps> = ({searchLoading, filteredAttestations}) => {
  const dispatch = useDispatch<Dispatch>();

  const { allAttesations, loading } = useSelector(
    (state: RootState) => state.attesation
  );

  useEffect(() => {
    dispatch.attesation.handleGetAllAttesations();
    // eslint-disable-next-line
  }, []);
  const finalAttestations = filteredAttestations || allAttesations;
  return (
    <>
      {(searchLoading || loading) && (
        <div className="flex-grow h-1 min-h-[300px]">
        <div className="h-full bg-k-grey-bg border border-k-border rounded-[12px] flex flex-col items-center justify-center">
          <ClipLoader size={30} color="#030A74" />
        </div>
        </div>
      )}
      {finalAttestations.length > 0 && !searchLoading && !loading ? (
        <div className="flex flex-col">
          {finalAttestations.map((attesation: IAttessation) => (
            <Attestation attestation={attesation} key={attesation.UID} isLoading={loading} />
          ))}
        </div>
      ) : (
        !searchLoading && !loading && (
          <div className="flex-grow h-1 min-h-[300px]">
            <div className="h-full bg-k-grey-bg border border-k-border rounded-[12px] flex flex-col items-center justify-center">
              <Typography variant="h4">No Attestation Found</Typography>
            </div>
          </div>
        )
      )}
    </>
  );
};

export default AllAttesations;
